import { ProfilerProduct } from "@/features/profiler/types/ProfilerProduct";
import { getAssetPath } from "../../../../../lib/assetPath";
import { useTranslation } from "../../../../../lib/i18n";
import { useDataTranslation } from "../../../../../lib/i18n/data";

type FragranceDetailsProps = {
  feticheFragrance: ProfilerProduct ;
};

export const FragranceDetails = ({ feticheFragrance }: FragranceDetailsProps) => {
  const imagePath = `/fragrance-profiler/main-fragrances/${feticheFragrance.id}.avif`;
  const { t } = useTranslation();
  const { tData } = useDataTranslation();

  return (
    <>
      <div className="flex flex-col mt-10 rounded-t-full bg-white items-center relative z-1 max-w-[800px]">
        <img
          src={getAssetPath(imagePath)}
          alt={imagePath}
          className="w-full p-1 rounded-t-full"
        />
      </div>
      <div className="flex flex-col items-center gap-8 p-4 z-1">
        <div>
          <p className="text-[#050505] text-center font-garamond-italic text-[20px] italic font-normal">
            {t('results.fragrance.favoriteFragranceIs')}
          </p>
          <h1 className="text-[#050505] text-center font-bebas-kai text-[37px] font-normal leading-normal">
            {feticheFragrance.label}
          </h1>
          <p className="text-[#CE0A2C] text-center font-minion text-[14px] font-normal leading-[150%]">
            {tData('products', feticheFragrance.id, 'description', feticheFragrance.description)}
          </p>
        </div>
      </div>
    </>
  );
};

export const FragranceTag = ({ text }: { text: string }) => {
  return (
    <div className="flex px-2 py-1 justify-center items-center gap-[10px] rounded-[2px] border border-[#CE0A2C] bg-[#CE0A2C] backdrop-blur-sm">
      <p className="text-white font-minion text-[14px] font-normal leading-[150%]">
        {text}
      </p>
    </div>
  );
};
